<template>
    <div
        class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-4 px-lg-3 px-4 px-lg-0 my-3 my-lg-0">
        <div
            class="col-12 col-lg-6 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">
            <div class="col-12 d-flex justify-content-center text-start align-items-center flex-wrap w-75 mt-5">
                <span class="font- fuente-posm label-1 d-flex flex-wrap fuentes-clamp3">Reportes de Seguimiento.<br>
                    <span>Acorde a tu Marca</span>
                    <span class="font- label-2  fuente-nova mt-3 ps-3 w-100 fuentes-clamp4">
                        Cada semana enviaremos una recopilación del feedback generado por tus clientes.

                        <br><br>
                        Descubrirás el progreso de métricas clave para tu negocio, cómo NPS (Net Promoter Score).
                    </span>
                </span>
            </div>
        </div>
        <div
            class="col-12 col-lg-6 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden mt-lg-5">
            <div class="col-12 d-flex justify-content-center text-start align-items-center flex-wrap px-lg-4">
                <div
                    class="spaceMedia col-lg-9 col-12 position-relative d-flex justify-content-center align-items-center align-content-center">
                    <img :src="a53" class="img-fluid w-100">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'page5',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a1: require('@/assets/images/a1.png'),
            a53: require('@/assets/images/a53.webp')
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        }
    },
}
</script>
<style lang="css" scoped>
.cubeSpace {
    overflow: hidden;
    height: auto;
    width: 100vw;
    height: 100vh;
}

.label-1 {
    color: var(--color-2);
    font-size: 70px;
    line-height: 1.1;
    max-width: 950px;
    word-wrap: break-word;
}

.label-2 {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.1;
}

@media (max-width: 992px) and (min-width: 768px) {
    .label-1 {
        font-size: 60px;
    }

    .label-2 {
        font-size: 27px;
    }
}

@media (max-width: 767px) and (min-width: 0) {
    .label-1 {
        font-size: 28px;
    }

    .label-2 {
        font-size: 19px;
    }
}
</style>